export default __webpack_public_path__ + "static/media/facebook.f0c7a6de.svg";